export const GET_BUSINESS_SUGESTIONS = 'GET_BUSINESS_SUGETIONS';
export const SET_BUSINESS_SUGESTIONS = 'SET_BUSINESS_SUGESTIONS';
export const CREATE_SLUG_INFORMATION = 'CREATE_SLUG_INFORMATION';
export const SET_SLUG_INFORMATION = 'SET_SLUG_INFORMATION';
export const GET_RATINGS = "GET_RATINGS";
export const SET_RATINGS = "SET_RATINGS";
export const GET_REVIEWS = "GET_REVIEWS";
export const SET_REVIEWS = "SET_REVIEWS";
export const CREATE_REVIEWS_FROM_SLUG = "GET_REVIEWS_FROM_SLUG";
export const PICK_RATING_DATA = "PICK_RATING_DATA";